/* eslint-disable */
import * as React from "react";
import { ContextReport1 } from "../Context";
import { ComponentTitle } from "../../../components/ComponentTitle";
import { ComponentSourcetitle } from "../../../components/ComponentSourcetitle";
import { ComponentPreloader } from "../../../components/ComponentPreloader";
import { useData1 } from "../data/useData1";
import { useChart1 } from "../transformers/useChart1";
import { useHookSubscribe } from "../../../shared/hooks/hookSubscribe";
import HighchartsChart, { Chartpoint } from "../../../../charts/components/HighchartsChart";
import { ComponentContextReadyState } from "@sa/rep-core";
import {
  useParameter,
  useDictionaryItem,
  yearToCropYearShort,
  castUnit,
  GLOBAL_UNIT,
  useExport,
  useSubscriptionProviderContext,
} from "../../../shared";
import { first, last } from "lodash";
import { dictionaryService } from "../../../dataFlow";

export const ComponentChart1: React.FC<{ context: ContextReport1 }> = (props) => {
  const {
    actions: { setSource },
  } = useSubscriptionProviderContext();

  const context = props.context;
  const orderedCountriesIds = useHookSubscribe(null, context.orderedCountriesIds$);
  const olapCountriesProduction = useHookSubscribe(null, context.olapCountriesProduction$);
  const olapCountriesYield = useHookSubscribe(null, context.olapCountriesYield$);
  const olapForecastCountriesYield = useHookSubscribe(null, context.olapForecastCountriesYield$);
  const olapCountriesArea = useHookSubscribe(null, context.olapCountriesArea$);
  const olapWorldProduction = useHookSubscribe(null, context.olapWorldProduction$);

  const worldStart = castUnit(olapWorldProduction?.data.rows[0]?.cells[0]?.value, GLOBAL_UNIT.PRODUCTION_MMT, GLOBAL_UNIT.PRODUCTION_MMT);
  const worldEnd = castUnit(olapWorldProduction?.data.rows[1]?.cells[0]?.value, GLOBAL_UNIT.PRODUCTION_MMT, GLOBAL_UNIT.PRODUCTION_MMT);

  const productionByYear = useData1(olapCountriesProduction);
  const yieldByYearCurrentForecast = useData1(olapForecastCountriesYield);
  const yieldByYear = useData1(olapCountriesYield);
  const areaHarvestedByYear = useData1(olapCountriesArea); // Area harvested by year

  const chartData = useChart1({
    productionByYear,
    yieldByYearCurrentForecast,
    yieldByYear,
    areaHarvestedByYear,
    orderedCountriesIds,
  });

  const [parameterValues] = useParameter<number[]>("@calendar");
  const [, calendarName] = useDictionaryItem(dictionaryService, "slides-calendar", first(parameterValues));
  const year = calendarName ? Number(calendarName) : new Date().getFullYear() - 1;
  const source = useHookSubscribe(null, context.sources$);
  const exportBuilder = useExport();
  React.useEffect(() => {
    exportBuilder.set("source", source);
    setSource(source);
  }, [source]);

  const handleChartHover = (point: Chartpoint | undefined) => {
    context.highlightData.next(point?.attributes || {});
  };

  const hasData = chartData && productionByYear && yieldByYearCurrentForecast && yieldByYear && areaHarvestedByYear;
  if (window["exportMode"]) {
    window["exportReady"] = hasData && context.readyState !== ComponentContextReadyState.Loading;
  }
  if (!window["exportMode"] && (!hasData || context.readyState === ComponentContextReadyState.Loading)) {
    return <ComponentPreloader />;
  }

  const title = `World production: ${yearToCropYearShort(year - 6)}: ${
    worldStart ? `${worldStart?.toFixed(0)} mmt` : ""
  } - ${yearToCropYearShort(year + 10)}: ${worldEnd ? `${worldEnd?.toFixed(0)} mmt` : ""}`;
  return (
    <>
      <ComponentTitle>{title}</ComponentTitle>
      <ComponentSourcetitle>Source: {source}</ComponentSourcetitle>
      <HighchartsChart data={chartData} onHover={handleChartHover} loader={<ComponentPreloader />} />
    </>
  );
};
